import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MDiscountCode } from '../MDiscountCode';
import Dialog from '../atoms/Dialog';
import IconShoppingCart from '../atoms/IconShoppingCart';
import IconClose from '../atoms/IconClose';
import { MButton } from '../atoms/MButton';
import { MBox } from '../atoms/MBox';
import { MText } from '../atoms/MText';

import { fadeInUp, fadeOutDown } from '../transitions';

import { getDiscountCodeStyleFromTheme } from '../helpers/style';

export const primary = '#f02c3c';
export const secondary = '#fbfee5';
export const gray = '#b3b4b6';

const DiscountCodePopupContentCon = styled.div`
  & .mr-discount-code-popup__title-con {
    position: relative;

    & .mr-discount-code-popup__close {
      position: absolute;
      top: 15px;
      right: 15px;
      cursor: pointer;
    }
  }

  & .mr-custom-icon::before {
    content: '\\e916';
    color: #fff;
    font-family: 'turbo';
  }
`;
export const MDiscountCodePopup = props => {
  const { open } = props;

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="325px"
      borderRadius={4}
      mobileBorderRadius={4}
      transitionIn={fadeInUp}
      transitionOut={fadeOutDown}
    >
      <MDiscountCodePopupContent {...props} />
    </Dialog>
  );
};

export const MDiscountCodePopupContent = props => {
  const {
    theme,
    shopURL,
    checkout,
    renderDiscountCodePopupInDiv,
    cartPageDiscountConfig,
    isDiscountCodeEnabled,
    getDiscountCodeFromApps,
    getMrDiscountCode,
    isSkipShopifyDiscountAPICall,
  } = props;

  const onClose = async () => {
    renderDiscountCodePopupInDiv({ open: false, theme });
    await checkout({ action: 'checkout' });
  };

  return (
    <DiscountCodePopupContentCon className="mr-discount-code-popup">
      <MBox // id="mr-alert-dialog-title"
        backgroundColor={theme.discountCodePopupTitleBackgroundColor}
        padding="15px"
        className="mr-discount-code-popup__title-con"
      >
        <MText
          color={theme.discountCodePopupTitleTextColor}
          fontSize={theme.discountCodePopupTitleFontSize}
          mobileFontSize={theme.discountCodePopupTitleMobileFontSize}
          fontStyle={theme.discountCodePopupTitleFontStyle}
          fontWeight={theme.discountCodePopupTitleFontWeight}
          textDecoration={theme.discountCodePopupTitleTextDecoration}
          textAlignment={theme.discountCodePopupTitleTextAlignment}
          fontFamily={theme.discountCodePopupTitleFontFamily}
          padding={theme.discountCodePopupTitlePadding}
          margin={theme.discountCodePopupTitleMargin}
          className="mr-discount-code-popup__title-text"
        >
          {theme.discountCodePopupTitleText}
        </MText>
        <IconClose
          onClick={onClose}
          fontSize={12}
          color={theme.discountCodePopupTitleTextColor}
          className="mr-discount-code-popup__close"
        />
      </MBox>
      <MBox
        backgroundColor={theme.discoundCodeWidgetBackgroundColor}
        padding="10px 20px"
        className="mr-discount-code-popup__discount-con"
      >
        <MDiscountCode
          onApply={checkout}
          isBordered={false}
          discountCodeStyles={getDiscountCodeStyleFromTheme(theme)}
          shopURL={shopURL}
          cartPageDiscountConfig={cartPageDiscountConfig}
          isDiscountCodeEnabled={isDiscountCodeEnabled}
          getDiscountCodeFromApps={getDiscountCodeFromApps}
          isDiscountCodePopup
          isSkipShopifyDiscountAPICall={isSkipShopifyDiscountAPICall}
        />
      </MBox>
      <MButton
        onClick={() => {
          checkout({ code: getMrDiscountCode() || '', action: 'checkout' });
        }}
        buttonStyle={theme.bottomBarButtonStyle}
        backgroundColor={theme.bottomBarButtonColor}
        borderColor={theme.bottomBarButtonColor}
        borderRadius={0}
        textColor={theme.bottomBarButtonTextColor}
        fontSize={theme.bottomBarButtonFontSize}
        mobileFontSize={theme.bottomBarButtonMobileFontSize}
        fontStyle={theme.bottomBarButtonFontStyle}
        fontWeight={theme.bottomBarButtonFontWeight}
        textDecoration={theme.bottomBarButtonTextDecoration}
        textAlignment={theme.bottomBarButtonTextAlignment}
        fontFamily={theme.bottomBarButtonFontFamily}
        padding="15px 15px 15px 15px"
        width="100%" // padding={theme.bottomBarButtonPadding}
        // margin={theme.bottomBarButtonMargin}
        className="mr-discount-code-popup__checkout-btn"
      >
        {[
          'iguana-au.myshopify.com',
          'iguana-us.myshopify.com',
          'iguana-ger.myshopify.com',
          'iguana-es.myshopify.com',
          'iguana-fr.myshopify.com',
          'iguanade.myshopify.com',
        ].includes(shopURL) ? (
          <span className="mr-custom-icon" />
        ) : (
          <IconShoppingCart
            fontSize={theme.bottomBarButtonFontSize}
            mobileFontSize={theme.bottomBarButtonMobileFontSize}
            color={theme.bottomBarButtonTextColor}
          />
        )}
        {theme.discountCodePopupCheckoutText}
      </MButton>
    </DiscountCodePopupContentCon>
  );
};

MDiscountCodePopupContent.propTypes = {
  theme: PropTypes.object,
  shopURL: PropTypes.string,
  checkout: PropTypes.func,
  renderDiscountCodePopupInDiv: PropTypes.func,
  cartPageDiscountConfig: PropTypes.object,
  isDiscountCodeEnabled: PropTypes.bool,
  getDiscountCodeFromApps: PropTypes.func,
  getMrDiscountCode: PropTypes.func,
  isSkipShopifyDiscountAPICall: PropTypes.bool,
};
